// extracted by mini-css-extract-plugin
module.exports = {"baseForm":"BaseForm_baseForm__fRyx9"};